import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url, inputData) =>
  await AxiosConfig.create('post', url).call(inputData).getResponseData();

function useDashboardFI(content, inputData) {
  const { data, _error, isLoading, isValidating, mutate } = useSWR(
    `/dashboard-fi/${content}`,
    (url) => fetcher(url, inputData),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL,
      revalidateOnFocus: true,
    }
  );
  return {
    datas: data?.data,
    res: {
      status: data?.code || _error?.response?.status,
      statusText: data?.message || _error?.response?.statusText,
    },
    isLoading,
    isValidating,
    mutate: mutate,
  };
}

export default useDashboardFI;
